import React from "react"
import "./color.css"

const HalfStar = () => {
	return (
		<div className="half-star">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="484.05"
				height="488.51"
				viewBox="0 0 484.05 488.51"
			>
				<defs>
					<pattern
						id="pattern"
						preserveAspectRatio="none"
						width="100%"
						height="100%"
						viewBox="0 0 3229 513"
					></pattern>
				</defs>
				<g id="star_half_full" transform="translate(-13.93 -11)">
					<rect
						id="Rectangle_3"
						data-name="Rectangle 3"
						width="484.05"
						height="75.2"
						transform="translate(13.93 424.31)"
						opacity="0.4"
						fill="url(#pattern)"
					/>
					<path
						id="Path_6"
						data-name="Path 6"
						d="M146.57,292.75,37.29,213.63s-21.63-12.81-15.37-32.45c6.54-19.92,31.31-17.07,31.31-17.07H188.41L230,35.48S235.36,11,255.86,11c20.77,0,25.9,24.48,25.9,24.48L323.3,164.11l135.18-.29s25-2.56,31.59,17.36c6.26,19.64-15.37,32.16-15.37,32.16l-109.57,79.4,42.12,128.64s10,23.05-6.83,35.29c-16.79,12-35.29-4.84-35.29-4.84l-109.28-79.4-109,79.69s-18.5,16.79-35.29,4.55S105,421.39,105,421.39Z"
						fill="#FFD700"
					/>
					<path
						id="Path_7"
						data-name="Path 7"
						d="M255.86,339.14h0l126.07,91.64L333.55,282.5l126.36-91.64H303.95L255.86,42.87Z"
						fill="#fff"
						fillRule="evenodd"
					/>
					<path
						id="Path_8"
						data-name="Path 8"
						className="half-star-fill"
						d="M26.76,179.48c9.68-10.53,26.47-8.54,26.47-8.54h140.3L231.1,54.83c6.83-23.62,12.24-36.43,24.47-36.14,11.38,0,16.79,11.1,24.48,34.15l38.14,118.11,140.3-.29s17.08-1.71,26.75,8.82c-13.66-6-109.86-.57-171.61,0L270.09,40.88c-7.69-24.76-23.34-20.77-29,1.71L199.22,179.48C134.9,178.34,33.3,170.94,26.76,179.48Z"
						fill="#FFD700"
					/>
				</g>
			</svg>
		</div>
	)
}

export default HalfStar
